function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames';
import { node, bool } from 'prop-types';

var SideMenu = function SideMenu(_ref) {
  var _classNames;

  var children = _ref.children,
      inFlex = _ref.inFlex;

  var rootStyles = classNames((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.inFlex, inFlex), _classNames));

  return React.createElement(
    'div',
    { className: rootStyles, 'data-hook': 'side-menu' },
    children
  );
};

SideMenu.defaultProps = {
  inFlex: false
};

SideMenu.propTypes = {
  inFlex: bool,
  children: node
};

export default SideMenu;
//# sourceMappingURL=SideMenu.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/SideMenu.js